import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps";

import { useTranslation } from "react-i18next";

const TemplateCustomerAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, load = true, label, disabled = false, infoText, error, helperText, selectFirst }) => {

    const { t } = useTranslation();

    return (
        <AsyncAutoCompleteContained
            label={label ?? t("common.customer")}
            url="/autocompleteApi/GetTemplateCustomer"
            valueId={valueId}
            load={load}
            onChange={onChange}
            disabled={disabled}
            infoText={infoText}
            error={error}
            helperText={helperText}
            selectFirst={selectFirst }
        />
    );
};

export default TemplateCustomerAutoComplete;
